import { useRoutes, Navigate } from "react-router-dom";
import WebsiteLayout from "../Pages/Website/Layout/Layout";
import LandingPage from "../Pages/Website/LandingPage/LandingPage";
import AboutUs from "../Pages/Website/AboutUs/AboutUs";
import Services from "../Pages/Website/ServicesPage/Services";
import Works from "../Pages/Website/Works/Works";
import Blogs from "../Pages/Website/Blogs/Blogs";
import Careers from "../Pages/Website/Careers/Careers";
import ContactUs from "../Pages/Website/ContactUs/ContactUs";
import AdminLayout from "../Pages/Admin/AdminLayout/AdminLayout";
import Dashboard from "../Pages/Admin/Dashboard/Dashboard";
import ServicesAdmin from "../Pages/Admin/Services/Services";
import AddService from "../Pages/Admin/Services/AddService";
import EditService from "../Pages/Admin/Services/EditService";
import Testimonial from "../Pages/Admin/Testimonial/Testimonial";
import AddTestimonial from "../Pages/Admin/Testimonial/AddTestimonial";
import EditTestimonial from "../Pages/Admin/Testimonial/EditTestimonial";
import Page404 from "../Pages/Page404/Page404";
import ServiceDetail from "../Pages/Website/ServicesPage/ServiceDetail";
import Marquee from "../Pages/Admin/Marquee/Marquee";
import AddMarquee from "../Pages/Admin/Marquee/AddMarquee";
import EditMarquee from "../Pages/Admin/Marquee/EditMarquee";
import Contacts from "../Pages/Admin/Contacts/Contacts";
import FAQ from "../Pages/Admin/FAQ.js/FAQ";
import AddFAQ from "../Pages/Admin/FAQ.js/AddFAQ";
import EditFAQ from "../Pages/Admin/FAQ.js/EditFAQ";
import Stats from "../Pages/Admin/Stats/Stats";
import AddStats from "../Pages/Admin/Stats/AddStats";
import EditStats from "../Pages/Admin/Stats/EditStats";
import Clients from "../Pages/Admin/Clients/Clients";
import AddClients from "../Pages/Admin/Clients/AddClients";
import EditClients from "../Pages/Admin/Clients/EditClients";
import TimelineAdmin from "../Pages/Admin/Timeline/Timeline";
import Users from "../Pages/Admin/Users/Users";
import Profile from "../Pages/Admin/Profile/Profile";
import AddTimeline from "../Pages/Admin/Timeline/AddTimeline";
import EditTimeline from "../Pages/Admin/Timeline/EditTimeline";
import WorksAdmin from "../Pages/Admin/Works/Works";
import AddWork from "../Pages/Admin/Works/AddWork";
import EditWork from "../Pages/Admin/Works/EditWork";
import WorkDetail from "../Pages/Website/Works/WorkDetail";
import JobDetail from "../Pages/Website/Careers/JobDetail";
import BlogDetail from "../Pages/Website/Blogs/BlogDetail";
import ApplyJob from "../Pages/Website/Careers/ApplyJob";
import JobsAdmin from "../Pages/Admin/Careers/Jobs";
import AddJob from "../Pages/Admin/Careers/AddJob";
import EditJob from "../Pages/Admin/Careers/EditJob";
import JobCategoriesAdmin from "../Pages/Admin/Careers/JobCategories";
import ApplicationsAdmin from "../Pages/Admin/Careers/ApplicationsList";
import ApplicationDetail from "../Pages/Admin/Careers/ApplicationDetail";
import BlogsAdmin from "../Pages/Admin/Blogs/BlogsListing";
import AddBlog from "../Pages/Admin/Blogs/AddBlog";
import EditBlog from "../Pages/Admin/Blogs/EditBlog";
import BlogCategoriesAdmin from "../Pages/Admin/Blogs/BlogCategories";
import SiteSettings from "../Pages/Admin/Settings/SiteSettings";
import ProjectVault from "../Pages/Admin/ProjectVault/ProjectVault";

// Auth Components
import Login from "../Pages/Auth/Login";
import Unauthorized from "../Pages/Auth/Unauthorized";
import AuthGuard from "../Components/Guards/AuthGuard";
import GuestGuard from "../Components/Guards/GuestGuard";

const Routes = () => {
  const routes = useRoutes([
    {
      path: "/",
      element: <WebsiteLayout />,
      children: [
        { index: true, element: <LandingPage /> },
        // ...
        {
          path: "login",
          element: (
            <GuestGuard>
              <Login />
            </GuestGuard>
          ),
        },
        {
          path: "auth/login",
          element: (
            <GuestGuard>
              <Login />
            </GuestGuard>
          ),
        },
        {
          path: "unauthorized",
          element: <Unauthorized />,
        },
        {
          path: "aboutUs",
          element: <AboutUs />,
        },

        // Services
        {
          path: "services",
          children: [
            { index: true, element: <Services /> },
            { path: ":slug", element: <ServiceDetail /> },
          ],
        },

        // Works
        {
          path: "works",
          children: [
            { index: true, element: <Works /> },
            { path: ":slug", element: <WorkDetail /> },
          ],
        },

        // Careers
        {
          path: "careers",
          children: [
            { index: true, element: <Careers /> },
            { path: ":slug", element: <JobDetail /> },
          ],
        },
        {
          path: "apply/:id",
          element: <ApplyJob />,
        },
        // Blogs
        {
          path: "blogs",
          children: [
            { index: true, element: <Blogs /> },
            { path: ":slug", element: <BlogDetail /> },
          ],
        },
        {
          path: "contactUs",
          element: <ContactUs />,
        },
        {
          path: "*",
          element: <Page404 />,
        },
      ],
    },
    {
      path: "admin",
      element: (
        <AuthGuard allowedRoles={["superadmin", "admin", "editor"]}>
          <AdminLayout />
        </AuthGuard>
      ),
      children: [
        {
          index: true,
          element: <Navigate to="dashboard" replace />,
        },
        {
          path: "dashboard",
          element: (
            <AuthGuard module="dashboard">
              <Dashboard />
            </AuthGuard>
          ),
        },

        // Services
        {
          path: "services",
          element: (
            <AuthGuard module="services">
              <ServicesAdmin />
            </AuthGuard>
          ),
        },
        {
          path: "add-service",
          element: (
            <AuthGuard module="services">
              <AddService />
            </AuthGuard>
          ),
        },
        {
          path: "edit-service/:id",
          element: (
            <AuthGuard module="services">
              <EditService />
            </AuthGuard>
          ),
        },

        // Works
        {
          path: "works",
          element: (
            <AuthGuard module="works">
              <WorksAdmin />
            </AuthGuard>
          ),
        },
        {
          path: "add-work",
          element: (
            <AuthGuard module="works">
              <AddWork />
            </AuthGuard>
          ),
        },
        {
          path: "edit-work/:id",
          element: (
            <AuthGuard module="works">
              <EditWork />
            </AuthGuard>
          ),
        },

        // Clients
        {
          path: "clients",
          element: (
            <AuthGuard module="clients">
              <Clients />
            </AuthGuard>
          ),
        },
        {
          path: "add-clients",
          element: (
            <AuthGuard module="clients">
              <AddClients />
            </AuthGuard>
          ),
        },
        {
          path: "edit-clients/:id",
          element: (
            <AuthGuard module="clients">
              <EditClients />
            </AuthGuard>
          ),
        },

        // Testimonial
        {
          path: "testimonial",
          element: (
            <AuthGuard module="testimonial">
              <Testimonial />
            </AuthGuard>
          ),
        },
        {
          path: "add-testimonial",
          element: (
            <AuthGuard module="testimonial">
              <AddTestimonial />
            </AuthGuard>
          ),
        },
        {
          path: "edit-testimonial/:id",
          element: (
            <AuthGuard module="testimonial">
              <EditTestimonial />
            </AuthGuard>
          ),
        },

        // Marquee
        {
          path: "marquee",
          element: (
            <AuthGuard module="marquee">
              <Marquee />
            </AuthGuard>
          ),
        },
        {
          path: "add-marquee",
          element: (
            <AuthGuard module="marquee">
              <AddMarquee />
            </AuthGuard>
          ),
        },
        {
          path: "edit-marquee/:id",
          element: (
            <AuthGuard module="marquee">
              <EditMarquee />
            </AuthGuard>
          ),
        },

        // FAQ
        {
          path: "faq",
          element: (
            <AuthGuard module="faq">
              <FAQ />
            </AuthGuard>
          ),
        },
        {
          path: "add-faq",
          element: (
            <AuthGuard module="faq">
              <AddFAQ />
            </AuthGuard>
          ),
        },
        {
          path: "edit-faq/:id",
          element: (
            <AuthGuard module="faq">
              <EditFAQ />
            </AuthGuard>
          ),
        },

        // Stats
        {
          path: "stats",
          element: (
            <AuthGuard module="stats">
              <Stats />
            </AuthGuard>
          ),
        },
        {
          path: "add-stats",
          element: (
            <AuthGuard module="stats">
              <AddStats />
            </AuthGuard>
          ),
        },
        {
          path: "edit-stats/:id",
          element: (
            <AuthGuard module="stats">
              <EditStats />
            </AuthGuard>
          ),
        },

        // Timeline
        {
          path: "timeline",
          element: (
            <AuthGuard module="timeline">
              <TimelineAdmin />
            </AuthGuard>
          ),
        },
        {
          path: "add-timeline",
          element: (
            <AuthGuard module="timeline">
              <AddTimeline />
            </AuthGuard>
          ),
        },
        {
          path: "edit-timeline/:id",
          element: (
            <AuthGuard module="timeline">
              <EditTimeline />
            </AuthGuard>
          ),
        },

        {
          path: "contacts",
          element: (
            <AuthGuard module="contacts">
              <Contacts />
            </AuthGuard>
          ),
        },

        // Careers Admin
        {
          path: "jobs",
          element: (
            <AuthGuard module="jobs">
              <JobsAdmin />
            </AuthGuard>
          ),
        },
        {
          path: "add-job",
          element: (
            <AuthGuard module="jobs">
              <AddJob />
            </AuthGuard>
          ),
        },
        {
          path: "edit-job/:id",
          element: (
            <AuthGuard module="jobs">
              <EditJob />
            </AuthGuard>
          ),
        },
        {
          path: "job-categories",
          element: (
            <AuthGuard module="jobs">
              <JobCategoriesAdmin />
            </AuthGuard>
          ),
        },
        {
          path: "applications",
          element: (
            <AuthGuard module="applications">
              <ApplicationsAdmin />
            </AuthGuard>
          ),
        },
        {
          path: "application-detail/:id",
          element: (
            <AuthGuard module="applications">
              <ApplicationDetail />
            </AuthGuard>
          ),
        },

        // Blogs Admin
        {
          path: "blogs",
          element: (
            <AuthGuard module="blogs">
              <BlogsAdmin />
            </AuthGuard>
          ),
        },
        {
          path: "add-blog",
          element: (
            <AuthGuard module="blogs">
              <AddBlog />
            </AuthGuard>
          ),
        },
        {
          path: "edit-blog/:id",
          element: (
            <AuthGuard module="blogs">
              <EditBlog />
            </AuthGuard>
          ),
        },
        {
          path: "blog-categories",
          element: (
            <AuthGuard module="blogs">
              <BlogCategoriesAdmin />
            </AuthGuard>
          ),
        },

        // Users (Superadmin only)
        {
          path: "users",
          element: (
            <AuthGuard allowedRoles={["superadmin"]}>
              <Users />
            </AuthGuard>
          ),
        },

        {
          path: "settings",
          element: (
            <AuthGuard module="settings">
              <SiteSettings />
            </AuthGuard>
          ),
        },
        {
          path: "project-vault",
          element: (
            <AuthGuard allowedRoles={["superadmin"]}>
              <ProjectVault />
            </AuthGuard>
          ),
        },
        { path: "profile", element: <Profile /> },
      ],
    },
  ]);

  return routes;
};

export default Routes;
